















import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator';
import SInputBase from './SInputBase.vue';

// Datepicker is based on jQuery.
import jQuery from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

@Component({
  components: {
    SInputBase,
  },
})
export default class SDatepicker extends Vue {
  @Prop({ type: Boolean, required: true }) private isValid!: boolean;
  @Prop({ type: Boolean, required: true }) private hasWarning!: boolean;
  @Prop({ required: true }) private errorMessages!: string[] | null;

  @Prop(String) private value!: string | null;
  @Ref() private readonly inputRef!: SInputBase;
  private jQueryInput!: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  private inputValue = this.value || '';

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  @Watch('value')
  private changeValue() {
    this.inputValue = this.value || '';
  }

  @Watch('inputValue')
  @Emit('input')
  private handleInput(): string | null {
    return (
      this.inputValue &&
      this.inputValue
        .replace(/^(\d{4})-([2-9])-(\d{2})$/, '$1-0$2-$3') // YYYY-M-DD
        .replace(/^(\d{4})-(\d{2})-([4-9])$/, '$1-$2-0$3') // YYYY-MM-D
        .replace(/^(\d{4})-([2-9])-([4-9])$/, '$1-0$2-0$3') // YYYY-M-D
        .replace(/^(\d{4})([1-9])([4-9])$/, '$1-0$2-0$3') // YYYYMD
        .replace(/^(\d{4})(0\d|10|11|12)([4-9])$/, '$1-$2-0$3') // YYYYMMD
        .replace(/^(\d{4})([2-9])(\d{2})$/, '$1-0$2-$3') // YYYYMDD
        .replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3') // YYYYMMDD
      || null
    );
  }

  @Emit('input')
  private handleInputOnBlur(): string | null {
    return (
      this.inputValue &&
      this.inputValue
        .replace(/^(\d{4})-(1)-([4-9])$/, '$1-0$2-0$3') // YYYY-1-D
        .replace(/^(\d{4})-(1)-(\d{2})$/, '$1-0$2-$3') // YYYY-1-DD
      || null
    );
  }

  @Watch('inputValue')
  private dateSelected() {
    if (this.inputValue && this.$dayjs.strict(this.inputValue).isValid()) {
      this.jQueryInput.datepicker('hide');
      this.$emit('date-selected', this.inputValue);
    }
  }

  private mounted() {
    this.jQueryInput = jQuery(this.inputRef.inputRef);
    this.jQueryInput.datepicker({
      dateFormat: 'yy-mm-dd',
      showOn: 'none',
      onSelect: (date: string) => {
        this.inputValue = date;
        this.inputRef.focus();
      },
    });
  }
}
